<template>
  <v-app>
    <v-content>
      <router-view></router-view>
    </v-content>
  </v-app>
</template>

<script>

export default {
  name: 'App',
};
</script>

<style lang="scss">
  // .v-btn:not(.v-btn--floating) {
  //   border-radius: 8px
  // }
  .theme--light.application {
    background: #ffffff;
    color: #6F6F6F;
  }
</style>
